import { Coordinates } from "../../graphql/generated";

const toLatLng = (coordinates: Coordinates) => ({
  lat: coordinates.latitude,
  lng: coordinates.longitude,
});

export default toLatLng;
